import { render, staticRenderFns } from "./FooterLicense.vue?vue&type=template&id=cd40f2cc&"
import script from "./FooterLicense.vue?vue&type=script&lang=js&"
export * from "./FooterLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports